import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NotificationStatus } from 'src/app/library/enums/notifications/notifications.enum';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';
import { INotificationResponseModel } from 'src/app/modules/notifications/interfaces/notification-response-model';
import { NotificationService } from 'src/app/modules/notifications/services/notification.service';

@Component({
    selector: 'app-notifications-tab-dialog',
    templateUrl: './notifications-tab-dialog.component.html',
    styleUrls: ['./notifications-tab-dialog.component.scss']
})
export class NotificationsTabDialogComponent implements OnInit {
    public notifications$: Observable<INotificationResponseModel[]>;
    public unreadNotifications$: Observable<INotificationResponseModel[]>;
    public unreadNotificationCount$: Observable<number>;

    constructor(
        public dialogRef: MatDialogRef<NotificationsTabDialogComponent>,
        public userAuthService: UserAuthService,
        public notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.notifications$ = this.notificationService.notifications$;
        this.unreadNotifications$ =
            this.notificationService.unreadNotifications$;
        this.unreadNotificationCount$ =
            this.notificationService.unreadNotificationCount$;
    }

    public toggleReadNotification(
        notification: INotificationResponseModel
    ): void {
        if (notification) {
            if (notification.notificationStatusId == NotificationStatus.Read) {
                this.notificationService.unreadNotification(
                    notification.notificationId
                );
            } else {
                this.notificationService.readNotification(
                    notification.notificationId
                );
            }
        }
    }

    public onNotificationView(notification: INotificationResponseModel): void {
        if (notification) {
            if (
                notification.notificationStatusId == NotificationStatus.Unread
            ) {
                this.notificationService.readNotification(
                    notification.notificationId
                );
            }
            this.router.navigate([notification.uri], {
                relativeTo: this.route
            });
        }
        this.closeDialog();
    }

    public readAllNotifications(): void {
        this.notificationService.readAllUnreadNotifications();
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }

    public onNotificationsScrollDown(): void {
        this.notificationService.GetNotificationsFromLastId();
    }
}
